import { getEngineApiClient } from '../../api-client/axios-client.js'

const state = {
  productsLoaded: false,
  products: []
}

const getters = {
  getCountyHotels: (state, getters) => {
    // find hotels that have at least one room whose occupancy is
    // less than or equal to our number of passengers
    // this is largely to deal with single passenger parties as some hotels do not have single rooms
    let hotels = state.products.filter(prod => {
      return (
        prod.productType.productTypeCode === 'HTL' &&
        prod.tariffs.findIndex(t => {
          return t.minOccupancy <= getters.getPassengersToRoom
        }) > -1
      )
    })
    hotels = hotels.map(hotel => {
      return {
        ...hotel,
        rank: parseInt(hotel.rating.substring(0, 1))
      }
    })
    return hotels.sort((a, b) => (a.rank > b.rank ? -1 : 1))
  },
  getCountyExcursions: state => {
    return state.products.filter(prod => {
      return (
        (prod.productType.productTypeCode === 'EXCR' ||
          prod.productType.productTypeCode === 'TRA') &&
        prod.fromTimeHours < 18
      )
    })
  },
  getCountyEntertainments: state => {
    return state.products.filter(prod => {
      return (
        ((prod.productType.productTypeCode === 'EXCR' ||
          prod.productType.productTypeCode === 'TRA') &&
          prod.fromTimeHours >= 18) ||
        prod.productType.productTypeCode === 'REST'
      )
    })
  },
  getCountyTransfersIn: state => {
    return state.products.filter(prod => {
      return prod.productType.productTypeCode === 'TRAI'
    })
  },
  getCountyTransfersOut: state => {
    return state.products.filter(prod => {
      return prod.productType.productTypeCode === 'TRAO'
    })
  }
}

const mutations = {
  setProductsLoaded: (state, payload) => {
    state.productsLoaded = payload
  },
  setProducts: (state, payload) => {
    state.products = payload
  }
}

const actions = {
  async initialiseCountyData({ commit, dispatch, rootState }, payload) {
    if (rootState.start.fromDate != null && rootState.start.noOfNights > 0) {
      // set that we are loading product
      commit('setProductsLoaded', false)

      const client = getEngineApiClient()
      try {
        const response = await client.get(
          `/Cache/ProductDetails?countyId=${payload.countyId}` +
            `&county=${
              payload.countyName
            }&departureDate=${payload.fromDate.toISOString()}` +
            `&returnDate=${payload.toDate.toISOString()}`
        )

        // map so that we can parse out the fromTimeHours and toTimeHours
        // makes later filtering a bit simpler
        const data = response.data.map(prod => {
          return {
            productId: prod.productId,
            title: prod.title,
            productType: prod.productType,
            productCode: prod.productCode,
            fromCity: prod.fromCity,
            fromPoint: prod.fromPoint,
            fromTime: prod.fromTime,
            fromTimeHours: parseInt(prod.fromTime.substring(0, 2)),
            toCity: prod.toCity,
            toPoint: prod.toPoint,
            toTime: prod.toTime,
            toTimeHours: parseInt(prod.toTime.substring(0, 2)),
            rating: prod.rating,
            description: prod.description,
            images: prod.images,
            tariffs: prod.tariffs
          }
        })

        // commit the mutation
        commit('setProducts', data)
        // confirm we have loaded what we need
        commit('setProductsLoaded', true)
      } catch (error) {
        dispatch('setFatalError', error)
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
